import React from 'react'
// ##
import RepsTable from '../../modules/Rep/components/RepsTable'

export default function RepPage() {
  return <RepsTable />
}
